(() => {
  angular
    .module('gm.common.services')
    .factory('GmFeVersion', GmFeVersion);

  function GmFeVersion(
    $q,
    $http,
    $interval,
    FrontendVersion,
    $log,
    $rootScope,
    $timeout
  ) {
    'ngInject';

    const FRONTEND_VERSION_FILE = '/version.txt';
    const GLOBAL_FE_NOTIFICATION_FIELD = 'oldFrontendVersion';
    const GLOBAL_OFFLINE_NOTIFICATION_FIELD = 'lostInternetConnection';

    const CHECK_FRONTEND_VERSION_INTERVAL = 30000;
    const OFFLINE_CHECK_FRONTEND_VERSION_INTERVAL = 1000;

    let _checkVersionInterval = null;

    if (!$rootScope.globalAlerts) {
      $rootScope.globalAlerts = {};
    }

    function reCreateInterval(isOnline) {
      if (_checkVersionInterval) {
        $interval.cancel(_checkVersionInterval);
      }

      _checkVersionInterval = $interval(
        checkFrontendVersion,
        isOnline
          ? CHECK_FRONTEND_VERSION_INTERVAL
          : OFFLINE_CHECK_FRONTEND_VERSION_INTERVAL
      );
    }

    function getFrontendVersion() {
      const versionDefer = $q.defer();

      $http.get(FRONTEND_VERSION_FILE, {
        cache: false,
        params: {
          t: Date.now(),
        },
      })
      .then(({ data }) => versionDefer.resolve(data),
        () => versionDefer.reject('Can\'t get app version.'));

      return versionDefer.promise;
    }

    function checkFrontendVersion() {
      return getFrontendVersion()
        .then(
          (hash) => {
            if (hash !== FrontendVersion) {
              $log.debug('need to refresh pages', hash, FRONTEND_VERSION_FILE);
            }

            showOrHideOldVersionNotification(hash !== FrontendVersion);
          }, error => $log.error(error)
        );
    }

    function showOrHideOldVersionNotification(isNeedShow) {
      if ($rootScope.globalAlerts[GLOBAL_FE_NOTIFICATION_FIELD] !== isNeedShow) {
        $timeout(() => { $rootScope.globalAlerts[GLOBAL_FE_NOTIFICATION_FIELD] = isNeedShow; });
      }
    }

    return {
      init() {
        $rootScope.$watch(
          `globalAlerts.${GLOBAL_OFFLINE_NOTIFICATION_FIELD}`, isOffline =>
            reCreateInterval(!isOffline)
        );

        return checkFrontendVersion();
      }
    };
  }
})();
